// extracted by mini-css-extract-plugin
module.exports = {"logo":"style__logo__PgcIE","logoPlaceholder":"style__logoPlaceholder__rhuQd","logoNoClick":"style__logoNoClick__Fp35x"};